import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { FormTextField } from '@/common/components/form-text-field/FormTextField.tsx';
import { FormNumberField } from '@/common/components/form-number-field/FormNumberField.tsx';
import { Form } from '@/common/components/form/Form.tsx';
import { FormSelectField } from '@/common/components/form-select-field/FormSelectField.tsx';

const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: FormTextField,
    NumberField: FormNumberField,
    SelectField: FormSelectField,
  },
  formComponents: {
    FormElement: Form,
  },
});

export { useAppForm, withForm, withFieldGroup, useFieldContext, useFormContext };
